<div class="app-splash-screen" [ngStyle]="{ left: windowWidth }" *ngIf="showSplash">
    <img *ngIf="!greyBackground" class="splash-img" [src]="imgService.getImage('logo-welcome.png')" (error)="imgService.onImgError('logo-welcome.png', $event)">
    <div class="grey-background" *ngIf="greyBackground"></div>
    <div class="app-loader"></div>
</div>